import { Component } from '@angular/core';

@Component({
  selector: 'app-course-lock-screen',
  templateUrl: './course-lock-screen.component.html',
  styleUrls: ['./course-lock-screen.component.css']
})
export class CourseLockScreenComponent {

}
